package diana.soleil.design.iraniancanadienbazzar.core.firebase

/**
 * The credential a native Sign in with Apple flow hands back: Apple's identity token plus the
 * **un-hashed** nonce that was used for the request. Firebase re-hashes [rawNonce] and compares it
 * against the `nonce` claim inside [idToken], which is what stops a stolen token being replayed —
 * so the two must come from the same authorization request.
 */
data class AppleIdCredential(
    val idToken: String,
    val rawNonce: String,
)

/**
 * Holds the platform's native Sign in with Apple provider (iOS `ASAuthorizationAppleIDProvider`),
 * injected from the entry point like [GoogleSignInController] and the other platform capabilities.
 * `null` means this platform has no wired Apple flow, so the sign-in screens hide the Apple button
 * (no dead affordance). The credential is exchanged for a Firebase session by
 * [AuthService.signInWithApple]. The provider returns `null` when the user cancels or the flow fails.
 *
 * App Review requires this on iOS whenever another third-party sign-in (Google) is offered —
 * guideline 4.8.
 */
class AppleSignInController(
    val provideCredential: (suspend () -> AppleIdCredential?)? = null,
) {
    val isAvailable: Boolean get() = provideCredential != null
}
